import React from 'react';
import classNames from 'classnames';
import { CnAsyncSelect } from '@cainiaofe/cn-ui';
import { themeMap, defaultTheme, ThemeType } from '@/lowcode/common/types';
import './index.scss';

interface ThemeSetterProps {
  value?: ThemeType;
  onChange?: (theme: string) => void;
}

const themeList = (Object.keys(themeMap) as ThemeType[]).map((themeName: ThemeType) => {
  return {
    label: themeMap[themeName].label,
    value: themeName,
    color: themeMap[themeName].color,
  };
});

function ThemeSetter({ value = defaultTheme, onChange }: ThemeSetterProps) {
  const handleChange = (t: string) => {
    onChange?.(t);
  };

  const renderColorList = (colorList: string[], size = 'medium') => {
    return (
      <div className={classNames('colorList', { 'colorList-large': size === 'large' })}>
        {colorList.map((c: string, index) => {
          return <span key={index} style={{ backgroundColor: c }} />;
        })}
      </div>
    );
  };

  return (
    <div className="theme-picker">
      <CnAsyncSelect
        mode="single"
        popupClassName="theme-picker-popup"
        dataSource={themeList}
        value={value}
        onChange={(t) => {
          handleChange(t);
        }}
        itemRender={(item) => {
          return (
            <div className="theme-item">
              <div>{item.label}</div>
              {renderColorList(item?.color)}
            </div>
          );
        }}
      />
      {renderColorList(themeMap[value]?.color, 'large')}
    </div>
  );
}

export default ThemeSetter;
